<template>
  <div class="flex bg-soft rounded-lg p-0.5 gap-0.5 justify-center items-center">
    <vx-tooltip v-for="{ tooltip, icon, key, isDisabled } in buttonsProps"
                :key="key"
                :text="tooltip"
                position="bottom">
      <base-button :variant="key === selectedButtonValue ? 'bordered-icon-group-active' : 'bordered-icon-group'"
                   :tooltip-text="tooltip"
                   :disabled="isDisabled"
                   @click="selectedButtonValue = key"
      >
        <slot :slot-icon="icon"/>
      </base-button>
    </vx-tooltip>
  </div>
</template>

<script>

export default {
  name: 'ButtonsGroup',

  props: {
    buttonsProps: {
      type: Array,
      default: () => []
    },

    selectedButton: {
      type: String,
      required: true
    }
  },

  computed: {
    selectedButtonValue: {
      get() {
        return this.selectedButton
      },
      set(value) {
        this.$emit('select-button', value)
      }
    }
  }
}
</script>
